$(document).ready(function () {
  $('.hero_slider').slick({
    slidesToShow: 1,
    dots: true,
    centerPadding: "0px",
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
  });
  $(window).on('load resize orientationchange', function () {
    $('.slider_on').each(function () {
      var slider_on = $(this);
      if ($(window).width() > 767) {
        if (slider_on.hasClass('slick-initialized')) {
          slider_on.slick('unslick');
        }
      }
      else {
        if (!slider_on.hasClass('slick-initialized')) {
          slider_on.slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
          });
        }
      }
    });
  })
  $(window).on('load resize orientationchange', function () {
    $('.shop_slider').each(function () {
      var slider_on = $(this);
      if ($(window).width() > 1024 && $('.template-index').length) {
        // if (slider_on.hasClass('slick-initialized')) {
        //     slider_on.slick('unslick');
        // }
      } else {
        if (!slider_on.hasClass('slick-initialized')) {
          slider_on.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  dots: false
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              }
            ]
          });
        }
      }
    });
  })
  if ($(window).width() > 1024) {
    if ($('.shop_section .shop_col').length > 4) {
      $('.shop_slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });
    }
  }

  $(window).on('load resize orientationchange', function () {
    $('.on-ness-slider').each(function () {
      var on_ness_slider = $(this);
      if ($(window).width() > 767) {
        if (on_ness_slider.hasClass('slick-initialized')) {
          on_ness_slider.slick('unslick');
        }
      }
      else {
        if (!on_ness_slider.hasClass('slick-initialized')) {
          on_ness_slider.slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 526,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows: false,
                }
              }
            ]
          });
        }
      }
    });
  })
  if ($(window).width() > 767) {
    if ($('.on-ness-slider').length > 3) {
      $('.on-ness-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            }
          },
          {
            breakpoint: 525,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            }
          }
        ]
      });
    }
  }
  function shop_slider_arrow() {
    setTimeout(function () {
      var shop_sl_arrow = $('.shop_wrapper .product-card .product__image').outerHeight() / 2;
      $('.shop_slider .slick-arrow.slick-prev, .shop_slider .slick-arrow.slick-next').css("top", shop_sl_arrow);
    }, 800)
  }
  // shop_slider_arrow();
  $(window).on('load resize orientationchange', function () {
    // shop_slider_arrow();
  });


  if ($('.founders_main_wpr .founders_slide').length > 1) {
    $('.founders_main_wpr').slick({
      slidesToShow: 1,
      dots: false,
      centerPadding: "0px",
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            autoplay: false,
          }
        }
      ]
    });
  }

  $(".return-top-btn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  $('.facts-link a').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('supplement-facts-visible');
    //$('#supplement-facts').fadeIn();
  });

  $('.supplement-facts__close').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('supplement-facts-remove');
    setTimeout(function () {
      $('body').removeClass('supplement-facts-visible').removeClass('supplement-facts-remove');
    }, 300);
    //$('#supplement-facts').fadeOut();

  });

  $('.key-ingredients__all-button').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('key-ingredients__all-button--active');
    $(this).next('.key-ingredients__all-content').slideToggle();
  });

});

document.addEventListener('rebuy:cart.ready', function (event) {
  console.log('rebuy:cart.ready event', event.detail);
  if (window.location.hash === '#sidecart') {
    Rebuy.SmartCart.show();
  }
});


// FAQ Section

let faq = document.querySelectorAll('.fr-faq-block');

$(document).ready(function () {
  faq.forEach((item) => {
    var content = item.querySelector('.fr-faq-block-content');
    content.style.display = 'none';
    item.setAttribute('data-open', 'false');

    item.addEventListener('click', function () {
      item.getAttribute('data-open') === 'false' ? item.setAttribute('data-open', 'true') : item.setAttribute('data-open', 'false');
      if (item.getAttribute('data-open') === 'true') {
        $(content).slideDown(300);
      } else {
        $(content).slideUp(300);
      }
    });
  });
});




// Cart "Upgrade your Routine" upsell to bundle widget
document.addEventListener('rebuy.beforeAdd', function (event) {
  if (event.detail.widget.id !== '244307') {
    return;
  }

  console.log('rebuy.beforeAdd event from Upgrade your Routine widget', event.detail);

  const productLetsNeck = [41913537855671, 41913537888439, 41913537921207];
  const productEyeOpener = [38178244526263];
  const productTheWorks = [41532353872055];
  const productOvernightMagic = [38178260779191];
  const productDailyVSoothe = [41913504923831, 41913504956599, 41913504989367];
  const productGoldVibes = [38178251374775];
  const productCocoBliss = [41911083499703, 41911083532471, 41911083565239];
  const productMeNoPause = [38178257797303];
  const productActiveGlow = [38178236694711];
  const productLetMeSleep = [40990078304439];
  
  const bundleMapping = {
    // Merry and Bright Kit
    7868558344375: [...productLetsNeck, ...productEyeOpener],
    // Tight & Smooth Kit
    6231861100727: [...productLetsNeck, ...productTheWorks, ...productOvernightMagic],
    // Lift your Libido Kit
    7343742288055: [...productDailyVSoothe, ...productGoldVibes],
    // Vaginal Renewal Kit
    7285424586935: [...productDailyVSoothe, ...productCocoBliss],
    // Menopause Survival Kit
    6791196442807: [...productMeNoPause, ...productActiveGlow],
    // No More Night Sweats Kit
    7290925973687: [...productLetMeSleep, ...productMeNoPause]
  }

  const bundleIndividualProductIDs = bundleMapping[event.detail.product.id];

  setTimeout(() => {
    Rebuy.Cart.getItems().forEach(item => {
      if (bundleIndividualProductIDs.includes(item.variant_id)) {
        Rebuy.Cart.removeItem(item, () => {
          console.log('Product upsell to bundle - removed item complete', item);
        });
      }
    });
  }, 500);

});